import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { postPAJAG010 } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import Pagination from '../../../shared/components/Pagination';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import ResumeItem from '../../../shared/components/ResumeItem';
import SideNav from '../../../shared/components/SideNav';
const PAJAG010 = () => {
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('modDate');
    const [data, setData] = useState([]);
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [popupSendMailOpen, setPopupSendMailOpen] = useState(false);
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const handleOptionChange = (selectedValue) => {
        setSortBy(selectedValue);
    };

    const closePopup = () => {
        setPopupSendMailOpen(false);
    };

    const getListData = () => {
        postPAJAG010({ page, sortBy })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, sortBy]);

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">스크랩</h3>
                                <h3 className="resume__tit col">
                                    <span>
                                        * 최근 3개월 이내 스크랩한 인재의 이력서 중 공개중인 이력서만 열람 가능합니다.
                                    </span>
                                    <span>
                                        * 스크랩 한 후 회원이 비공개 처리 하였다면 해당 정보는 스크랩 목록에서 확인
                                        불가능합니다.
                                    </span>
                                </h3>
                                <div id="content-table">
                                    <div className="container">
                                        <div className="wrap-table">
                                            <div className="header-table-container">
                                                <div className="top-table j-end">
                                                    <div className="wrap-dropDown">
                                                        <div className="dropDowns" style={{ width: '160px' }}>
                                                            <Dropdown
                                                                placeholder=""
                                                                options={[
                                                                    { value: 'modDate', option: '업데이트순' },
                                                                    { value: 'addDate', option: '등록일순' },
                                                                ]}
                                                                name="sortBy"
                                                                value={sortBy}
                                                                onChange={handleOptionChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="table table-header table-results">
                                                    <div className="column column-1">제목</div>
                                                    <div className="column column-2">경력/형태/자격증</div>
                                                    <div className="column column-3">수정</div>
                                                    <div className="column column-4">관리</div>
                                                </div>
                                            </div>
                                            <ul className="table table-has-more-infomation PAJAG010">
                                                {data && data.length > 0 ? (
                                                    data?.map((result, index) => (
                                                        <ResumeItem
                                                            item={result}
                                                            key={index}
                                                            hasDelete={true}
                                                            showStar={false}
                                                            showEnvelope={true}
                                                            setPopupSendMailOpen={setPopupSendMailOpen}
                                                            setReceiver={setReceiver}
                                                            roleAction="C"
                                                            detailUrl="myPage"
                                                            refreshData={getListData}
                                                        />
                                                    ))
                                                ) : (
                                                    <div className="loading">데이터없습니다</div>
                                                )}
                                            </ul>
                                            <Pagination pages={pages} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};

export default PAJAG010;
